export default __webpack_public_path__ + "static/media/question-mark.afb1caca.svg";